var exports = {
  "UD": "ApplicationsTab.module__buttonContainer___bkI5Ry",
  "qI": "ApplicationsTab.module__listContainer___bkI5Ry",
  "DB": "ApplicationsTab.module__itemContainer___bkI5Ry",
  "k0": "ApplicationsTab.module__itemButton___bkI5Ry",
  "HS": "ApplicationsTab.module__itemLeft___bkI5Ry",
  "vi": "ApplicationsTab.module__itemAvatar___bkI5Ry",
  "KO": "ApplicationsTab.module__itemAvatarPlaceholder___bkI5Ry",
  "c2": "ApplicationsTab.module__itemTextBlock___bkI5Ry",
  "wH": "ApplicationsTab.module__itemTitleRow___bkI5Ry",
  "TJ": "ApplicationsTab.module__itemName___bkI5Ry",
  "YD": "ApplicationsTab.module__itemMetaRow___bkI5Ry",
  "v5": "ApplicationsTab.module__itemChevron___bkI5Ry",
  "p$": "ApplicationsTab.module__emptyState___bkI5Ry",
  "dc": "ApplicationsTab.module__spinnerContainer___bkI5Ry",
};

module.exports = exports;
